import React from 'react';

const SvgPg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PG_svg__b" fill="#fff">
        <use xlinkHref="#PG_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#PG_svg__a" />
      <path fill="#262626" mask="url(#PG_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#E8283F" mask="url(#PG_svg__b)" d="M0 0h28v20z" />
      <path
        fill="#FFF"
        mask="url(#PG_svg__b)"
        d="M6.667 16.667l-.943.276L6 16l-.276-.943.943.276.942-.276-.276.943.276.943zM6.667 8.667l-.943.276L6 8l-.276-.943.943.276.942-.276L7.333 8l.276.943zM3.333 12l-.942.276.276-.943-.276-.942.942.276.943-.276-.276.942.276.943zM9.333 11.333l-.942.276.276-.942-.276-.943.942.276.943-.276-.276.943.276.942z"
      />
      <path
        d="M18.861 9.266a.653.653 0 0 1-.289-.502V7.535c0-.181-.13-.285-.328-.22l-.758.254a1.16 1.16 0 0 1-.656 0l-.758-.253c-.181-.06-.201-.185-.04-.283l1.78-1.067a.43.43 0 0 0 .18-.502l-.253-.758c-.06-.181.02-.284.218-.219l.759.253a.442.442 0 0 0 .501-.18l1.067-1.778c.096-.16.217-.159.283.038l.253.759c.06.18.066.458 0 .656l-.253.758c-.06.181.039.328.22.328h1.228c.181 0 .404.127.502.289l1.067 1.779c.096.16.019.32-.154.354l-1.702.34a.552.552 0 0 0-.393.394l-.34 1.702c-.036.18-.192.251-.355.154l-1.779-1.067z"
        fill="#FFD84E"
        mask="url(#PG_svg__b)"
      />
    </g>
  </svg>
);

export default SvgPg;
